export default "__VITE_ASSET__QmlGtTxf__"